import { Typography } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { updateLessonCourse } from '../../../../../../services/CourseService';
import { useDomain } from '../../../../../../states/AppDomainProvider';
import Logger from '../../../../../../utils/Logger';
import { useGetRemoteServiceWrapper } from '../../../../../hooks/RemoteServiceHooks';
import { useTeacherCourses } from '../../../../context/TeacherCourseContextProvider';
import './CourseActiveAction.scss';

const CourseActiveAction = () => {
  const { teacherCourseDomain, teacherCourseSearchCriteriaDomain } = useTeacherCourses();
  const { lessonCourses } = teacherCourseDomain.domainData;
  const { searchCriteria } = teacherCourseSearchCriteriaDomain.domainData;
  const { courseId } = searchCriteria;

  const course = (lessonCourses || []).find((l) => l.id === courseId) || { active: false };
  const {
    callRemoteServiceWrapper,
  } = useGetRemoteServiceWrapper();
  const { uiDomain } = useDomain();

  const handleSaveData = async (_e, newValue) => {
    try {
      await callRemoteServiceWrapper(async () => {
        course.active = newValue;
        await teacherCourseDomain.updateLessonCourses([...lessonCourses]);
        updateLessonCourse({
          courseId,
          active: newValue,
        });
      });
      await uiDomain.showSnackbar(true, 'success', 3000, `Couse status has been updated to ${newValue ? 'Active' : 'Inactive'}.`);
    } catch (e) {
      Logger.logWhenDebugModeIsOn(e);
    }
  };

  return (
    <div className='course-active-action'>
      <Typography variant='h6'>Course: </Typography>
      <ToggleButtonGroup size='small' onChange={handleSaveData} value={course.active} exclusive>
        <ToggleButton value>
          Active
        </ToggleButton>
        <ToggleButton value={false}>
          Inactive
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default CourseActiveAction;
